import {
  Action,
  Dispatch,
  ThunkAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import {
  addCategoryError,
  addCategorySuccess,
  addJewelleryError,
  addJewellerySuccess,
  addMetalError,
  addMetalSuccess,
  addStyleError,
  addStyleSuccess,
  addSubCategoryError,
  addSubCategorySuccess,
  deleteCategoryError,
  deleteCategorySuccess,
  deleteJewelleryError,
  deleteJewellerySuccess,
  deleteMetalError,
  deleteMetalSuccess,
  deleteStyleError,
  deleteStyleSuccess,
  deleteSubCategoryError,
  deleteSubCategorySuccess,
  getCategoriesError,
  getCategoriesSuccess,
  getMetalsError,
  getMetalsSuccess,
  getJewelleriesError,
  getJewelleriesSuccess,
  getJewelleryByIdError,
  getJewelleryByIdSuccess,
  getStylesError,
  getStylesSuccess,
  getSubCategoriesError,
  getSubCategoriesSuccess,
  setIsLoading,
  styleType,
  subcategoryType,
  updateCategoryError,
  updateCategorySuccess,
  updateJewelleryError,
  updateJewellerySuccess,
  updateMetalError,
  updateMetalSuccess,
  updateStyleError,
  updateStyleSuccess,
  updateSubCategoryError,
  updateSubCategorySuccess,
  setTotalCount,
  getJewelleryBySlugSuccess,
  getJewelleryBySlugError,
  getJewelleryBySkuSuccess,
  getJewelleryBySkuError,
} from "./reducer";
import {
  getOrders as getOrdersApi,
  addCategory as addCategoryApi,
  getCategories as getCategoriesApi,
  updateCategory as updateCategoryApi,
  deleteCategory as deleteCategoryApi,
  addSubCategory as addSubCategoryApi,
  getSubCategories as getSubCategoriesApi,
  updateSubCategory as updateSubCategoryApi,
  deleteSubCategory as deleteSubCategoryApi,
  addStyle as addStyleApi,
  getStyles as getStylesApi,
  updateStyle as updateStyleApi,
  deleteStyle as deleteStyleApi,
  addJewellery as addJewelleryApi,
  getJewelleries as getJewelleriesApi,
  getJewelleryById as getJewelleryByIdApi,
  updateJewellery as updateJewelleryApi,
  deleteJewellery as deleteJewelleryApi,
  addJewelleryMetal as addJewelleryMetalApi,
  getJewelleryMetals as getJewelleryMetalsApi,
  updateJewelleryMetal as updateJewelleryMetalApi,
  deleteJewelleryMetal as deleteJewelleryMetalApi,
  getJewelleryBySlug as getJewelleryBySlugApi,
  getJewelleryBySku as getJewelleryBySkuApi,
} from "helpers/backend_helper";
import { toast } from "react-toastify";
import { RootState } from "slices";

export type addCategoryBodyType = {
  name: String;
  image?: String;
  showRingSize: boolean;
  showBraceletLength: boolean;
  showStoneSize: boolean;
};
export type updateCategoryBodyType = {
  id: String;
  fields: {
    name?: string;
    image?: string;
    subcategories?: subcategoryType[];
    styles?: styleType[];
  };
};

export type updateDiscountBodyType = {
  id: string;
  fields: {
    type: String;
    value: number;
    products: {
      id: string;
      isNew: boolean;
      isDeleted: boolean;
    };
  };
};

export type addSubCategoryBodyType = {
  category: String;
  name: String;
  image?: String;
};
export type updateSubCategoryBodyType = {
  id: String;
  fields: {
    name?: string;
    image?: string;
  };
};

export type addStyleBodyType = {
  category: String;
  name: String;
  image?: String;
};

export type updateStyleBodyType = {
  id: String;
  fields: {
    name?: string;
    image?: string;
  };
};

export type addMetalBodyType = {
  type: string;
  carat: string;
  price: number;
};

export type updateJewelleryMetalBodyType = {
  id: string;
  fields: { type?: string; carat?: string; price?: number };
};

// Jewellery

export const addJewellery = (body: any) => async (dispatch: Dispatch) => {
  try {
    // dispatch(setIsLoading(true));
    const response: any = await addJewelleryApi(body);
    toast.success("Jewellery added Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(addJewellerySuccess(response.result));
    return response;
  } catch (error: any) {
    toast.error("Jewellery added Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(addJewelleryError(error));
  }
};

export const getJewelleries =
  (body: any): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getJewelleriesApi(body);
      // dispatch(setIsLoading(false));
      dispatch(getJewelleriesSuccess(response.result.data));
      dispatch(setTotalCount(response.result.totalCount));
    } catch (error: any) {
      // dispatch(setIsLoading(false));
      dispatch(getJewelleriesError(error));
    } finally {
      dispatch(setIsLoading(false)); // End loading
    }
  };

export const getJewelleryById =
  (id: string): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getJewelleryByIdApi(id);
      dispatch(setIsLoading(false));
      dispatch(getJewelleryByIdSuccess(response.result));
      return response.result;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getJewelleryByIdError(error));
    }
  };

export const getJewelleryBySlug =
  (slug: string): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getJewelleryBySlugApi(slug);
      console.log(response);
      dispatch(setIsLoading(false));
      dispatch(getJewelleryBySlugSuccess(response.result));
      return response.result;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getJewelleryBySlugError(error));
    }
  };

export const getJewelleryBySku =
  (slug: string): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getJewelleryBySkuApi(slug);
      console.log(response);
      dispatch(setIsLoading(false));
      dispatch(getJewelleryBySkuSuccess(response.result));
      return response.result;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getJewelleryBySkuError(error));
    }
  };

export const updateJewellery = (body: any) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    const response: any = await updateJewelleryApi(body);
    toast.success("Jewellery updated Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(updateJewellerySuccess(response.result));
    return response;
  } catch (error: any) {
    toast.error("Jewellery updated Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(updateJewelleryError(error));
  }
};

export const deleteJewellery = (id: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await deleteJewelleryApi(id);
    toast.success("Jewellery deleted Successfully", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteJewellerySuccess(id as any));
  } catch (error: any) {
    toast.error("Jewellery deleted Failed", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteJewelleryError(error));
  }
};

//Orders

export const getJewelleryOrders = createAsyncThunk(
  "jewellery/getJewelleryOrders",
  async (type: string) => {
    try {
      const response: any = await getOrdersApi(type);
      return response.result;
    } catch (error) {
      return error;
    }
  }
);

// Category

export const addCategory =
  (body: addCategoryBodyType) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await addCategoryApi(body);
      toast.success("Category added Successfully!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(addCategorySuccess(response.result));
    } catch (error: any) {
      toast.error("Category added Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(addCategoryError(error));
    }
  };

export const getCategories =
  (): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getCategoriesApi();
      dispatch(setIsLoading(false));
      dispatch(getCategoriesSuccess(response.result));
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getCategoriesError(error));
    }
  };

export const updateCategory =
  (body: updateCategoryBodyType) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await updateCategoryApi(body);
      toast.success("Category updated Successfully!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(updateCategorySuccess(response.result));
    } catch (error: any) {
      toast.error("Category updated Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(updateCategoryError(error));
    }
  };

export const deleteCategory = (id: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await deleteCategoryApi(id);
    toast.success("Category deleted Successfully", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteCategorySuccess(id as any));
  } catch (error: any) {
    toast.error("Category deleted Failed", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteCategoryError(error));
  }
};

// sub category
export const addSubCategory =
  (body: addSubCategoryBodyType) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await addSubCategoryApi(body);
      toast.success("Sub Category added Successfully!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(addSubCategorySuccess(response.result));
    } catch (error: any) {
      toast.error("Sub Category added Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(addSubCategoryError(error));
    }
  };

export const getSubCategories =
  (): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getSubCategoriesApi();
      dispatch(setIsLoading(false));
      dispatch(getSubCategoriesSuccess(response.result));
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getSubCategoriesError(error));
    }
  };

export const updateSubCategory =
  (body: updateCategoryBodyType) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await updateSubCategoryApi(body);
      toast.success("Sub Category updated Successfully!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(updateSubCategorySuccess(response.result));
    } catch (error: any) {
      toast.error("Sub Category updated Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(updateSubCategoryError(error));
    }
  };

export const deleteSubCategory = (id: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await deleteSubCategoryApi(id);
    toast.success("Sub Category deleted Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteSubCategorySuccess(id as any));
  } catch (error: any) {
    toast.error("Sub Category deleted Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteSubCategoryError(error));
  }
};
// Style
export const addStyle =
  (body: addStyleBodyType) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await addStyleApi(body);
      toast.success("Style added Successfully!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(addStyleSuccess(response.result));
    } catch (error: any) {
      toast.error("Style added Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(addStyleError(error));
    }
  };

export const getStyles =
  (): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getStylesApi();
      dispatch(setIsLoading(false));
      dispatch(getStylesSuccess(response.result));
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getStylesError(error));
    }
  };

export const updateStyle =
  (body: updateCategoryBodyType) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await updateStyleApi(body);
      toast.success("Style updated Successfully!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(updateStyleSuccess(response.result));
    } catch (error: any) {
      toast.error("Style updated Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(updateStyleError(error));
    }
  };

export const deleteStyle = (id: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await deleteStyleApi(id);
    toast.success("Style deleted Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteStyleSuccess(id as any));
  } catch (error: any) {
    toast.error("Style deleted Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteStyleError(error));
  }
};

// Jewellery Metal
export const addJewelleryMetal =
  (body: addMetalBodyType) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await addJewelleryMetalApi(body);
      toast.success("Jewellery Metal added Successfully!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(addMetalSuccess(response.result));
    } catch (error: any) {
      toast.error("Jewellery Metal added Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(addMetalError(error));
    }
  };

export const getJewelleryMetals =
  (): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getJewelleryMetalsApi();
      dispatch(setIsLoading(false));
      dispatch(getMetalsSuccess(response.result));
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getMetalsError(error));
    }
  };

export const updateJewelleryMetal =
  (body: updateJewelleryMetalBodyType) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await updateJewelleryMetalApi(body);
      toast.success("Jewellery Metal updated Successfully!", {
        autoClose: 2000,
      });
      dispatch(setIsLoading(false));
      dispatch(updateMetalSuccess(response.result));
    } catch (error: any) {
      toast.error("Jewellery Metal updated Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(updateMetalError(error));
    }
  };

export const deleteJewelleryMetal =
  (id: string) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      await deleteJewelleryMetalApi(id);
      toast.success("Jewellery Metal deleted Successfully!", {
        autoClose: 2000,
      });
      dispatch(setIsLoading(false));
      dispatch(deleteMetalSuccess(id as any));
    } catch (error: any) {
      toast.error("Jewellery Metal deleted Failed!", { autoClose: 2000 });
      dispatch(setIsLoading(false));
      dispatch(deleteMetalError(error));
    }
  };
